import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CTA from '../../Shared/CTA/CTA';
import { extractColors, formatHttpsUrl } from '@utils/utils';

export const PreFooterCTAStyles = styled.div`
  .cta-inside {
    padding: 130px 0 120px 0;
  }
`;

const PreFooterCTA = ({
  ctaBackgroundColor,
  buttonAndTextColors,
  ctaImage,
  ctaImageLocation,
  alignCtaContent,
  ctaHeader,
  firstCtaButtonText,
  firstCtaButtonUrl,
}) => {
  return (
    <PreFooterCTAStyles>
      <CTA
        isPreFooterCTA={true}
        backgroundColor={extractColors(ctaBackgroundColor)}
        buttonColors={extractColors(buttonAndTextColors)}
        image={formatHttpsUrl(ctaImage)}
        imageAlign={ctaImageLocation}
        contentAlign={alignCtaContent}
        headingText={ctaHeader}
        buttonText={firstCtaButtonText}
        buttonUrl={firstCtaButtonUrl}
        buttonAutomationId="stories-prefooter-cta"
        gtmClassName="gtm-ugc-view-homes"
      />
    </PreFooterCTAStyles>
  );
};

export default PreFooterCTA;

PreFooterCTA.propTypes = {
  alignCtaContent: PropTypes.string,
  buttonAndTextColors: PropTypes.string,
  ctaBackgroundColor: PropTypes.string,
  ctaHeader: PropTypes.string,
  ctaImage: PropTypes.string,
  ctaImageLocation: PropTypes.string,
  firstCtaButtonText: PropTypes.string,
  firstCtaButtonUrl: PropTypes.string,
};
